var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ 'slo-tab': true, active: _vm.active },on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_c('button',{directives:[{name:"stack-x",rawName:"v-stack-x:xs",arg:"xs"}]},[(typeof _vm.title === 'undefined')?_vm._t("default"):_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }